import { RHFInput } from '@talentmesh/ui/components/rhf-input';
import ProfileGroupForm from './ProfileGroupForm';
import UIStrings from '@/Utils/UIStrings';

const CompanyNameSection = () => {
    return (
        <ProfileGroupForm
            dataCy="CompanyNameSection"
            title={UIStrings.CompanyNameAsterisk}
            description={UIStrings.TheCompanyNameThatIsDisplayedToApplicants}
        >
            <div className="w-full max-w-md flex-1">
                <RHFInput id="companyName" name="companyName" type="text" fullWidth />
            </div>
        </ProfileGroupForm>
    );
};

export default CompanyNameSection;
